/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';

import {
  AbstractRestService,
  arrayOf,
  optimisticLockingOf,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';

import { Observable } from 'rxjs';
import { CustomFieldDetailsMapper } from './mappers/custom-field-details.mapper';
import { CustomFieldLisstItemMapper } from './mappers/custom-field-list-item.mapper';
import { CustomFieldDetailsDto } from './models/custom-field-details.dto';
import { CustomFieldListItemDto } from './models/custom-field-list-item.dto';

@Injectable()
export class CustomFieldRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  create(customField: CustomFieldDetailsDto): Observable<CustomFieldDetailsDto> {
    return this.httpPost(`${this.bp}/custom-fields`, customField, optimisticLockingOf(CustomFieldDetailsMapper));
  }

  update(customField: CustomFieldDetailsDto): Observable<CustomFieldDetailsDto> {
    return this.httpPut(`${this.bp}/custom-fields/${customField.customFieldId}`,
                        customField,
                        optimisticLockingOf(CustomFieldDetailsMapper));
  }

  activate(customField: CustomFieldDetailsDto): Observable<CustomFieldDetailsDto> {
    return this.httpPut(`${this.bp}/custom-fields/activate/${customField.customFieldId}`,
                        customField,
                        optimisticLockingOf(CustomFieldDetailsMapper));
  }

  deactivate(customField: CustomFieldDetailsDto): Observable<CustomFieldDetailsDto> {
    return this.httpPut(`${this.bp}/custom-fields/deactivate/${customField.customFieldId}`,
                        customField,
                        optimisticLockingOf(CustomFieldDetailsMapper));
  }

  get(id: ID): Observable<CustomFieldDetailsDto> {
    return this.httpGet(`${this.bp}/custom-fields/${id}`, optimisticLockingOf(CustomFieldDetailsMapper));
  }

  findAllAsDataSource(): SlicedDataSource<CustomFieldListItemDto> {
    return this.createSlicedDataSourceGet(`${this.bp}/custom-fields`, arrayOf(CustomFieldLisstItemMapper));
  }
}
